import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md rounded-xl border border-[#27272A] bg-[#121212] p-8 text-center">
        <XCircle className="h-12 w-12 text-neutral-500 mx-auto" />
        <h1 className="mt-4 font-black text-2xl tracking-tight">Payment cancelled</h1>
        <p className="text-neutral-400 text-sm mt-2">Nothing was charged. You can try again any time.</p>
        <Link to="/billing">
          <Button className="mt-8 bg-white text-black hover:bg-neutral-200 rounded-full w-full h-11 font-semibold">
            Back to billing
          </Button>
        </Link>
      </div>
    </div>
  );
}
